module.exports = __webpack_public_path__ + "static/media/coming-soon.dbfd057c.jpg";